import { render, staticRenderFns } from "./pressurelist.vue?vue&type=template&id=3d930e6d&"
import script from "./pressurelist.vue?vue&type=script&lang=ts&"
export * from "./pressurelist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pressurelist.vue"
export default component.exports